'use client';

import { Button } from '@material-tailwind/react';
import Image from 'next/image';
import Link from 'next/link';
import { motion } from 'framer-motion';

export default function HomePageMarketingContent() {
    // Animation variants
    const fadeInLeft = {
        hidden: { opacity: 0, x: -60 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.8, ease: 'easeOut' },
        },
    };

    const fadeInUp = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: 'easeOut' },
        },
    };

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.3,
            },
        },
    };

    return (
        <>
            <div className="mx-10 mt-14 mb-6 lg:mt-20 lg:mb-8 lg:mx-28">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    className="grid grid-cols-1 md:grid-cols-2"
                >
                    <motion.div variants={fadeInLeft} className="">
                        <Image
                            src="/images/blog1.webp"
                            height={500}
                            width={500}
                            alt="erp"
                        />
                    </motion.div>
                    <motion.div variants={staggerContainer} className="">
                        <motion.h2
                            variants={fadeInUp}
                            className="text-2xl font-semibold"
                        >
                            Understanding ERP: A Strategic Tool for Business
                            Transformation
                        </motion.h2>

                        <motion.div
                            variants={staggerContainer}
                            className="mt-4"
                        >
                            <motion.p variants={fadeInUp}>
                                Adopting ERP services has several advantages for
                                your company. ERP acts as a catalyst for
                                boosting productivity, accuracy, and strategic
                                decision-making by guaranteeing data accuracy,
                                improving reporting capabilities, and automating
                                tedious operations.
                            </motion.p>
                            <motion.p variants={fadeInUp} className="mt-4">
                                ERP provides you with the ability to handle
                                complexity with assurance and dexterity by
                                centralising data and establishing a single
                                source of reality.
                            </motion.p>
                            <motion.p variants={fadeInUp} className="mt-6">
                                ERP is essentially a strategic tool that
                                integrates important business operations like
                                supply chain management, manufacturing, finance,
                                and human resources. It is more than just
                                software. Consider it your company&apos;s
                                central nervous system, facilitating smooth
                                department-to-department communication, accurate
                                data, and efficient operations.
                            </motion.p>
                        </motion.div>

                        <motion.div variants={fadeInUp} className="mt-4">
                            <Link rel="canonical" href="/contact-sales">
                                <Button variant="gradient" color="blue">
                                    Contact Sales
                                </Button>
                            </Link>
                        </motion.div>
                    </motion.div>
                </motion.div>
            </div>
        </>
    );
}
